module.exports = __webpack_public_path__ + "img/icon-schedule-gray.475df3d0.svg";